
import {HomeComponent} from "./home/home.component";
import {LoginComponent} from "./login/login.component";
import {ContentComponent} from "./layout/content/content.component";
import {Routes, RouterModule} from "@angular/router";
import {UserlistComponent} from "./usermaster/userlist/userlist.component";
import {UserviewComponent} from "./usermaster/userview/userview.component"; 
import {EmailverifyComponent} from "./login/emailverify.component";
import {PagelistComponent} from "./pages/pagelist.component";
import {PageviewComponent} from "./pages/pageview.component";
import {AddpageComponent} from "./pages/addpage.component";
import { ResetPasswordComponent } from "./usermaster/resetpassword/resetpassword.component";
import { CategorylistComponent } from "./categoriesmaster/categorylist/categorylist.component";
import { CategoryviewComponent } from "./categoriesmaster/categoryview/categoryview.component";
import { AddcategoryComponent } from "./categoriesmaster/addcategory/addcategory.component";
import { CardlistComponent } from "./cardsmaster/cardlist/cardlist.component";
import { CardviewComponent } from "./cardsmaster/cardview/cardview.component";
import { AddcardComponent } from "./cardsmaster/addcard/addcard.component";
import { CardImageslistComponent } from './card_imagesmaster/card_imageslist/card_imageslist.component';
import { CardImagesviewComponent } from './card_imagesmaster/card_imagesview/card_imagesview.component';
import { AddcardImagesComponent } from './card_imagesmaster/addcard_images/addcard_images.component';
import { CardTextslistComponent } from './card_textsmaster/card_textslist/card_textslist.component';
import { CardTextsviewComponent } from './card_textsmaster/card_textsview/card_textsview.component';
import { AddcardTextsComponent } from './card_textsmaster/addcard_texts/addcard_texts.component';
import {AdminviewComponent} from "./admin/adminview.component";
import {AddadminComponent} from "./admin/addadmin.component";

const appRoutes: Routes = [
    {
        path: '',
        component: ContentComponent,
        children: [
            { path: 'home',component: HomeComponent},
            { path: 'users',component: UserlistComponent},
            { path: 'users/:id',component: UserviewComponent},

            { path: 'categories',component: CategorylistComponent},
            { path: 'categories/cards/:id',component: CardlistComponent},
            { path: 'categories/add', component: AddcategoryComponent },
            { path: 'categories/:id',component: CategoryviewComponent},
            { path: 'categories/update/:id', component: AddcategoryComponent },

            { path: 'cards',component: CardlistComponent},
            { path: 'cards/cardimages/:id',component: CardImageslistComponent},
            { path: 'cards/cardtexts/:id',component: CardTextslistComponent},
            { path: 'cards/add', component: AddcardComponent },
            { path: 'cards/:id',component: CardviewComponent},
            { path: 'cards/update/:id', component: AddcardComponent },

            // { path: 'card_images',component: CardImageslistComponent},
            { path: 'card_images/add/:cardid', component: AddcardImagesComponent },
            { path: 'card_images/:id',component: CardImagesviewComponent},
            { path: 'card_images/update/:id', component: AddcardImagesComponent },

            // { path: 'card_texts',component: CardTextslistComponent},
            { path: 'card_texts/add/:cardid', component: AddcardTextsComponent },
            { path: 'card_texts/:id',component: CardTextsviewComponent},
            { path: 'card_texts/update/:id', component: AddcardTextsComponent },

            { path: 'pages', component: PagelistComponent },
            { path: 'pages/add', component: AddpageComponent },
            { path: 'pages/:id', component: PageviewComponent },
            { path: 'pages/update/:id', component: AddpageComponent },

            { path: 'admin/:id', component: AdminviewComponent },
            { path: 'admin/update/:id', component: AddadminComponent },
        ]
    },
    { path: '', component: LoginComponent},
    { path: 'login', component: LoginComponent},
    { path: 'logout', component: LoginComponent},
    { path: 'verify/:key', component: EmailverifyComponent},
    { path: 'resetpassword/:authcode',component: ResetPasswordComponent},
    { path: '**', pathMatch: 'full', redirectTo: 'home'},
];
export const routing = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/app.routing.ts